(function (angular) {
	'use strict';

	angular
		.module('waitlistModule')
		.factory('addToWaitlistFactory', [
			'APP_BASE_PATH',
			'localStorageFactory',
			'urlFactory',
			addToWaitlistFunction
		]);

	function addToWaitlistFunction(
		APP_BASE_PATH,
		localStorageFactory,
		urlFactory) {
		
		var factory = {
			addToWaitlist: addToWaitlist,
			ofundAddToWaitlist: ofundAddToWaitlist
		};
		
		return factory;
		
		function addToWaitlist(email, feeWaiver, referralKey) {
			return urlFactory.postPromise(buildBaseUrl(email, feeWaiver, referralKey));
		}

		function ofundAddToWaitlist(email) {
			return urlFactory.postPromise(buildBaseUrl(email) + '&scheduleOnboardingEmails=false');
		}

		function buildBaseUrl(email, feeWaiver, referralKey) {
			localStorageFactory.setItem('emailcapture', email);

			var urlValue = '/add-to-waiting-list.json?email=' + encodeURIComponent(email);

			if(urlFactory.getUrlParam('clickid')) {
				urlValue = urlValue + '&clickid=' + urlFactory.getUrlParam('clickid');
			}

			if(urlFactory.getUrlParam('tph')) {
				urlValue = urlValue + '&tph=' + urlFactory.getUrlParam('tph');
			}

			if(angular.isDefined(feeWaiver)) {
				urlValue = urlValue + '&feeWaiver=' + feeWaiver;
			}

			if(angular.isDefined(referralKey)) {
				urlValue = urlValue + '&referralKey=' + referralKey;
			}

			return urlValue;
		}
	}
})(window.angular);